import { inject, Injectable } from '@angular/core';
import { SpriMockApiService } from '@spri/lib/mock-api';
import { user as userData } from 'app/mock-api/common/user/data';
import { assign, cloneDeep } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class UserMockApi {
  private _user = userData;

  private spriMockApiService = inject(SpriMockApiService);

  constructor() {
    // Register Mock API handlers
    this.registerHandlers();
  }

  /**
   * Register Mock API handlers
   */
  public registerHandlers(): void {
    // -----------------------------------------------------------------------------------------------------
    // @ User - GET
    // -----------------------------------------------------------------------------------------------------
    const getHandler = this.spriMockApiService.onGet('api/common/user');
    getHandler.reply(() => [200, cloneDeep(this._user)]);

    // -----------------------------------------------------------------------------------------------------
    // @ User - PATCH
    // -----------------------------------------------------------------------------------------------------
    const patchHandler = this.spriMockApiService.onPatch('api/common/user');
    patchHandler.reply(({ request }) => {
      // Get the user mock-api
      const user = cloneDeep(request.body.user);

      // Update the user mock-api
      this._user = assign({}, this._user, user);

      // Return the response
      return [200, cloneDeep(this._user)];
    });
  }
}
